import React from "react";
import QRcode from "../assets/imgs/QR.jpeg";
import styled from "styled-components";

const QRcontainer=styled.div`
background-color: rgb(0,0,0,0.5);`;

const Image=styled.img`
display:flex;
margin:0 auto;
height:100vh;`;


const QR=()=> <QRcontainer><Image src={QRcode}/></QRcontainer>

export default QR;